import axios from 'axios';

const influencersApi = axios.create({
  baseURL: 'https://crawler.influencers.buzzmonitor.com.br',
});

export default influencersApi;
